<h2 mat-dialog-title>{{ data.title | translate }}</h2>
<mat-dialog-content>
	<p>{{ data.message | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close>OK</button>
</mat-dialog-actions>